import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataButtonSetsValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'array',
            empty: false,
            mandatory: false
        };
    }
}
